<template>
    <k-page background="bg-white">
        <template v-slot:header>
            <profile-header/>
        </template>
        <k-container class="py-10">
            <div class="max-w-3xl mx-auto">
                <h1 class="text-3xl font-bold mb-8">{{ $t("investorVerification") }}</h1>
                <rejection-description></rejection-description>
            </div>
        </k-container>
        <template v-slot:footer>
            <k-footer/>
        </template>
    </k-page>
</template>

<script>
import ProfileHeader from '@investor/components/profile/ProfileHeader';
import RejectionDescription from '@investor/components/registration/RejectionDescription';

export default {
    components: {
        ProfileHeader,
        RejectionDescription
    }
};
</script>


